import { Directive, forwardRef, HostListener } from '@angular/core'
import { DefaultValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms'

const TRIM_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => TrimValueAccessorDirective),
  multi: true,
}

@Directive({
  selector: 'input[mmxTrim]',
  providers: [TRIM_VALUE_ACCESSOR],
  standalone: false,
})
export class TrimValueAccessorDirective extends DefaultValueAccessor {
  @HostListener('input', ['$event.target.value'])
    ngOnChange = (val: string) => {
      this.onChange(val.trim())
    }

  @HostListener('blur', ['$event.target.value'])
    ngOnBlur = (val: string) => {
      this.writeValue(val.trim())
      this.onTouched()
    }

  writeValue(value: any): void {
    if (typeof value === 'string') {
      value = value.trim()
    }

    super.writeValue(value)
  }
}
